import { Event } from '@angular/router';
import { Component, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef, ElementRef, AfterViewInit, HostListener, HostBinding } from '@angular/core';
import { UiSwitchComponent } from 'ngx-ui-switch';



@Component({
  selector: 'app-toggle-switch',
  templateUrl: './toggle-switch.component.html',
  styleUrls: ['./toggle-switch.component.scss']
})
export class ToggleSwitchComponent implements AfterViewInit {

  constructor(private cdr: ChangeDetectorRef, private domNode: ElementRef) { }

  @Input() on = 'On';
  @Input() off = 'Off';
  @Input() onValue = 'true';
  @Input() offValue = 'false';
  @Output() change: EventEmitter<any> = new EventEmitter();
  @ViewChild('switch', { static: true }) switch!: UiSwitchComponent;
  @ViewChild('switch', { static: true, read: ElementRef }) switchElement!: ElementRef;

  @HostListener('sl-focus', ['$event'])
  onCustomEvent(event: any) {
    this.SetFocus();
  }

  @HostListener('focusin')
  onHostFocusIn(): void {
    // When the component receives focus, set focus to the actual switch element
    this.SetFocus();
  }

  @Input()
  public set altValue(val: string) {
    const nextVal = (val === this.onValue);
    if (nextVal === this.value) { return; }
    this.value = (val === this.onValue);
    this.valueChange.emit(this.value);
    this.altValueChange.emit(this.altValue);
    this.UpdateSize();
  }
  public get altValue(): string {
    return (this.value === true) ? this.onValue : this.offValue;
  }
  @Output() altValueChange = new EventEmitter<string>();

  @Input() value = false;
  @Output() valueChange = new EventEmitter<boolean>();
  public enabled = true;
  public checkedLabel = 'On';
  public uncheckedLabel = 'Off';

  private switchOnLabel: HTMLElement | undefined;
  private switchOffLabel: HTMLElement | undefined;
  private _ready = false;
  ngAfterViewInit() {
    this.altValue = this.altValue;
    this.checkedLabel = this.on;
    this.uncheckedLabel = this.off;
    this.switchOnLabel = this.domNode.nativeElement.getElementsByClassName('switch-label-checked')[0];
    this.switchOffLabel = this.domNode.nativeElement.getElementsByClassName('switch-label-unchecked')[1];
    this._ready = true;
    this.UpdateSize();

  }
  Update() {
    this.cdr.detectChanges();
  }
  SetValue(val: boolean) {
    if ((val as any) === 'true') { val = true };
    if ((val as any) === 'false') { val = false };
    this.value = val;
    this.UpdateSize();
  }
  HandleChange(event: any) {
    this.value = this.switch.checked;

    this.valueChange.emit(this.value);
    this.altValueChange.emit(this.altValue);
    this.cdr.detectChanges();
    this.change.emit({
      originalEvent: event,
      value: this.switch.checked ? this.onValue : this.offValue,
      checked: event,
      label: this.switch.checked ? this.checkedLabel : this.uncheckedLabel
    });
    this.UpdateSize();
  }

  UpdateSize() {
    const e = document.createElement('div');
    e.style.setProperty('position', 'absolute');
    e.style.setProperty('left', '-1000px');
    e.style.setProperty('top', '-1000px');
    e.innerHTML = Math.max(this.checkedLabel.length, this.uncheckedLabel.length) === this.checkedLabel.length ? this.checkedLabel : this.uncheckedLabel;
    document.body.appendChild(e);
    if (this._ready === false) return;
    if (!this.switchOnLabel) return;
    const width = e.clientWidth;
    this.domNode.nativeElement.style.setProperty('--button-width', 'calc(' + (width / 16) + 'rem' + ' + (var(--switch-size,1.25rem) * 2.25)');
    e.remove();
  }

  /**
   * Sets focus to the toggle switch element
   */
  public SetFocus(): void {
    if (this.switchElement && this.enabled) {
      const switchThumb: HTMLElement = (this.switchElement.nativeElement as HTMLElement).getElementsByClassName('switch')[0] as HTMLElement;
      if (switchThumb) {
        const params: any = { focusVisible: true };
        switchThumb.focus(params as any);
      }
    }
  }

}
